import * as React from "react";
import {css, cx} from "emotion";

import "./select.scss";

import {cs}    from "@Common/react/chain-services";
import {keyed} from "@Common/react/keyed";
import {chain} from "@Common/utils/fs";

import {CaptureAutofill} from "../../../../capture-autofill";
import {Dropdown}        from "../../../../dropdown/dropdown";

import {KeyboardNav} from "./keyboard-nav/keyboard-nav";

export const Select = (
    {
        list, style=undefined, placeholder=undefined, itemToLabel=v=>v, itemToInfo=undefined,
        forcedExpandLeft=undefined, autoWidth= false, onChange, isSelected, isDisabled=undefined,
        captureOutsideClicks=false, // Use this if select is inside modal, if outside modal, don't use, it will be more natural
        xdQaName=undefined,
        autofill=undefined,
        className=undefined,
        expandClassName=undefined,
        ref=undefined,
        disabled=false,
        ...props
    }
) => cs(
    ["small", (_, next) => next(style?.height < 36)],
    ({small}) => Dropdown({
        forcedExpandLeft,
        renderToggle: ({showExpand, domRef, showingExpand}) => (
            <div
                className={cx(
                    "select select-513 toggle",
                    css`
                        --height: ${style?.height??36}px;
                    `,
                    {small, disabled},
                    style?.color,
                    className,
                )}
                style={{
                    ...style?.paddingLeft && {
                        paddingLeft: style.paddingLeft,
                    },
                }}
                onClick={() => !disabled && showExpand(!showingExpand)}
                ref={(dom) => {
                    domRef?.(dom);
                    ref?.(dom);
                }}
                xd-qa-type="dropdown"
                xd-qa-name={xdQaName}
                {...props}
            >

                {chain(
                    list?.findIndex(isSelected) ?? -1,
                    (itemIndex) => <>
                        <div
                            className={cx(
                                "label", css`
                                    font-size: ${style?.fontSize??14}px;
                                `,
                                {placeholder: itemIndex === -1}
                            )}
                            xd-qa-type="dropdown_item"
                            xd-qa-name={xdQaName+" Selected Item"}
                        >
                            {itemIndex > -1 ? itemToLabel(list[itemIndex]) : placeholder}
                        </div>
                        <div className={cx("info", {small})} xd-qa-type="label" xd-qa-name={xdQaName+" Info"}>
                            {itemIndex===-1 || !itemToInfo ? null : itemToInfo(list[itemIndex])}
                        </div>
                    </>,
                )}

                <div className={cx("dropdown-indicator", {small})} xd-qa-type="icon" xd-qa-name={xdQaName+ " Dropdown"}>
                    {!small ? (
                        <div className="up-down">
                            <i className="fa fa-chevron-up"/>
                            <i className="fa fa-chevron-down"/>
                        </div>
                    ) : (
                        <div className="down">
                            <i className="fa fa-angle-down"/>
                        </div>
                    )}
                </div>

                {autofill && (
                    CaptureAutofill({
                        name: autofill.name,
                        onChange: (str) => {
                            const item = autofill.getItem(str);
                            if (item) {
                                (autofill.onChange ?? onChange)(item);
                            }
                        },
                    })
                )}
            </div>
        ),
        renderExpand: ({position, width, close, domRef}) => cs(
            (_, next) => (
                <div
                    className={cx("select-513 expand", {capture: captureOutsideClicks}, expandClassName)} onClick={close}
                    ref={domRef}
                >
                    {next()}
                </div>
            ),
            (_, next) => (
                <div {...{
                    className: cx("box"),
                    style: {...position, width: autoWidth ? undefined: width},
                }}>
                    {next()}
                </div>
            ),
            ["keyboardNav", (_, next) => KeyboardNav({
                initFocus: list?.findIndex(isSelected),
                getList: () => list?.map((e) => itemToLabel(e).toLowerCase()),
                onSelect: (index) => {
                    onChange(list[index]);
                    close();
                },
                next,
            })],
            ({keyboardNav}, next) => <>
                {next()}
                {keyboardNav.renderFilter()}
            </>,
            ({keyboardNav}) => (
                <div {...{
                    className: cx("list", css`
                        //--height: ${style?.height??36}px;
                        --height: ${36}px;
                    `),
                    ref: keyboardNav.parentRef,
                    onClick: (e) => e.stopPropagation(),
                }}>
                    {list?.map((item, i) => cs(
                        keyed(i),
                        ["disabled", (_, next) => next(isDisabled?.(item))],
                        ({disabled}) => (
                            <div {...{
                                className: cx("item", {
                                    selected: keyboardNav.isFocused(i),
                                    disabled,
                                }),
                                onClick: () => {
                                    if (disabled) {
                                        return;
                                    }
                                    onChange(item);
                                    close();
                                },
                                ref: keyboardNav.itemRef(i),
                                "xd-qa-type": "dropdown_item",
                                "xd-qa-name": xdQaName + " " + itemToLabel(item),
                            }}>
                                <div className="label" title={itemToLabel(item)}>
                                    {keyboardNav.renderItem(itemToLabel(item), {
                                        highlightClassName: "hl",
                                    })}
                                </div>
                                <div className="info">
                                    {!itemToInfo ? null : itemToInfo(item)}
                                </div>
                            </div>
                        ),
                    ))}
                </div>
            ),
        ),
    })
);
